import ImageSlim from "./components/imageSlim/index.vue";
import ImageCommonTool from "./components/imageTool/index.vue";
import TextGenerateImageTool from "./components/TextGenerateImageTool/index.vue";
import PortraitStyleRepaintingTool from "./components/PortraitStyleRepaintingTool/index.vue";
import IntelligenceWordArtTool from "./components/IntelligenceWordArtTool/index.vue";
import TextToSpeechTool from "./components/TextToSpeech/index.vue";
import OpticalCharacterRecognitionTool from "./components/OpticalCharacterRecognitionTool/index.vue";
import NaturalLanguageSearchTool from "./components/NaturalLanguageSearchTool/index.vue";

import { setSingleImageSlimResource } from "./components/imageSlim/index";
import { useGetIdentifyInfo } from "./hooks/useIdentifyInfo";

// 一些引用
[
  "/frontend/mugeda-resource/uploader.js",
  "/frontend/mugeda-resource/bundle.js",
].forEach((path) => {
  const scriptEl = document.createElement("script");
  scriptEl.src = path;
  document.head.appendChild(scriptEl);
});

const MugedaAiTool = {
  install: function (Vue: any) {
    Vue.component("ImageSlim", ImageSlim);
    Vue.component("ImageCommonTool", ImageCommonTool);
    Vue.component("TextGenerateImageTool", TextGenerateImageTool);
    Vue.component("PortraitStyleRepaintingTool", PortraitStyleRepaintingTool);
    Vue.component("IntelligenceWordArtTool", IntelligenceWordArtTool);
    Vue.component("TextToSpeechTool", TextToSpeechTool);
    Vue.component(
      "OpticalCharacterRecognitionTool",
      OpticalCharacterRecognitionTool
    );
    Vue.component("NaturalLanguageSearchTool", NaturalLanguageSearchTool);
  },
};
export {
  ImageSlim,
  ImageCommonTool,
  TextGenerateImageTool,
  PortraitStyleRepaintingTool,
  IntelligenceWordArtTool,
  TextToSpeechTool,
  OpticalCharacterRecognitionTool,
  setSingleImageSlimResource,
  useGetIdentifyInfo,
  NaturalLanguageSearchTool,
};
export default MugedaAiTool;
